/**
 * One featured tag per speaker card — the category of the event that speaker
 * is appearing for, shown top-left on the carousel card.
 *
 * The tag is organizer-maintained data, not inferred from copy: it reads
 * straight off `CHIEvent.category`. Speakers published from the database
 * resolve through their event slug. When a speaker is attached to an event
 * that carries no category (a database-only event), the card falls back to a
 * neutral label rather than rendering an empty pill or guessing a subject.
 */

import { EVENTS, type CHIEventCategory } from "@/lib/eventsData";

export const SPEAKER_FALLBACK_TAG = "Featured";

const CATEGORY_BY_EVENT_SLUG: Map<string, CHIEventCategory> = new Map(
  EVENTS.map(event => [event.slug, event.category]),
);

/**
 * Resolve the tag for a speaker from their event category. Always returns a
 * non-empty string so the pill never renders blank.
 */
export function speakerTagForEvent(eventSlug: string | undefined): string {
  if (!eventSlug) return SPEAKER_FALLBACK_TAG;
  return CATEGORY_BY_EVENT_SLUG.get(eventSlug) ?? SPEAKER_FALLBACK_TAG;
}
